import { Box } from "@mui/material";
import { Button } from "../../shared/button/button";
import { useEffect, useState } from "react";
import { ContainerStyled, ItemContainer } from "./styles";
import { NormalText } from "../../shared/styles";
import { useDispatch, useSelector } from "react-redux";
import { getAgenda } from "../../redux/actions/agenda.actions";
import { Loader } from "../../shared/loader/loader";
import { CopyButton } from "../../shared/copy-button/copy-button";
import { CheckboxStyled } from "../styles";
import { CreateTransactionExcel } from "./create-transaction-excel";

export const MultiplePaymentsContainer = ({ user }) => {
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [selectTransactionForm, setSelectTransactionForm] = useState("excel");

  const {
    data: agenda,
    isLoading: isLoadingAgenda,
    error,
  } = useSelector((state) => state.agenda);

  const dispatch = useDispatch();

  function handleChange(idwallet) {
    if (selectedContacts.includes(idwallet)) {
      setSelectedContacts(
        selectedContacts.filter((contact) => contact !== idwallet)
      );
    } else {
      setSelectedContacts([...selectedContacts, idwallet]);
    }
  }

  function handleDownloadTemplate() {
    const link = document.createElement("a");
    link.href = "/template-multiple-payments.xlsx";
    link.download = "template-multiple-payments.xlsx";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  function handleSelectTransactionForm(form) {
    setSelectTransactionForm(form);
  }

  useEffect(() => {
    if (user?.usuarioid) {
      dispatch(getAgenda(user?.usuarioid));
    }
  }, [dispatch, user?.usuarioid]);

  return (
    <ContainerStyled>
      {isLoadingAgenda ? (
        <Loader />
      ) : (
        <>
          <NormalText color="#0F110C" size={14} sx={{ marginBottom: "8px" }}>
            Create multiple transactions simultaneously by either selecting from
            your saved aliases or uploading an Excel file. This feature allows
            you to process batch payments efficiently, saving you time when
            handling multiple transfers.
          </NormalText>
          <Box display={"flex"} gap={"8px"} mb={"16px"}>
            <Button
              label="Upload Excel"
              onClick={() => handleSelectTransactionForm("excel")}
              type="regular"
            />
            <Button
              label="Download template"
              onClick={() => handleDownloadTemplate()}
              type="regular"
            />
            {/* <Button
              label="Select aliases"
              onClick={() => handleSelectTransactionForm("aliases")}
              type="regular"
              tooltipLabel={"This feature is not available yet"}
              isDisabled={true}
            /> */}
          </Box>
          {selectTransactionForm === "aliases" ? (
            agenda?.map((contact) => (
              <ItemContainer
                key={contact?.idwallet}
                isSelected={selectedContacts.includes(contact?.idwallet)}
              >
                <NormalText
                  color={
                    selectedContacts.includes(contact?.idwallet)
                      ? "#EDEDED"
                      : "#0F110C"
                  }
                  size={12}
                >
                  {contact?.alias} - {contact?.nombre + " " + contact?.apellido}{" "}
                  - {contact?.email}
                </NormalText>
                <Box display={"flex"} gap={"8px"} alignItems={"center"}>
                  <CopyButton
                    textToCopy={contact?.walletadress}
                    tooltipText="Copy wallet address"
                    iconColor={
                      selectedContacts.includes(contact?.idwallet)
                        ? "#EDEDED"
                        : "#0F110C"
                    }
                  />
                  <CheckboxStyled
                    sx={{
                      "& .MuiSvgIcon-root": { fontSize: "16px !important" },
                    }}
                    disableRipple
                    onChange={() => handleChange(contact?.idwallet)}
                    checked={selectedContacts.includes(contact?.idwallet)}
                  />
                </Box>
              </ItemContainer>
            ))
          ) : (
            <CreateTransactionExcel />
          )}
        </>
      )}
    </ContainerStyled>
  );
};
